import { v4 as uuidv4 } from 'uuid';

import { CollectionName } from '../constants';
// import { AssetDto } from '../models/asset.dto';
import { BaseDto } from '../models/base.dto';

export type SjItemData = Omit<BaseDto, 'id'> & Record<string, unknown>;

export const getCollectionNameByDtoId = (some: string): CollectionName | undefined => {
  for (const collection of Object.values(CollectionName)) {
    if (some.startsWith(collection)) return collection;
  }

  return undefined;
};

export const getCollectionItemData = (item: BaseDto): SjItemData => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, ...data } = item;

  return data;
};

export const getCollectionDtoIdPrefix = (collectionName: CollectionName) => collectionName;
export const generateDtoId = (collectionName: CollectionName) => {
  return `${getCollectionDtoIdPrefix(collectionName)}-${uuidv4()}`;
};
